<template>
    <el-button class="fleet-button-grid-item" :class="{ 'selected-button': setClassButton }"
        @click="selectGroup(group.uid)">
        {{ group.verbose_name }}
    </el-button>
</template>

<script>
import { mapGetters } from 'vuex';
export default {

    props: {
        group: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {

        };
    },

    watch: {

    },

    computed: {
        ...mapGetters([
            'getVehicleInspectionStatus',
        ]),
        setClassButton() {
            return this.group.uid == this.$store.getters.getSelectedFleet;
        },
    },

    methods: {
        selectGroup(groupUid) {
            this.$store.dispatch('setSelectedFleetForDataDisplay', groupUid);
            this.$store.axios.get(window.config.api_root_url + '/vehicle/stats/?out_of_fleet=false&client_group=' + groupUid).then((response) => {
                this.$store.dispatch('setNumberVehiclesToInspect', response.data.objects_count);
            });
            this.$store.dispatch('remoteGet', {
                url: '/vehicle/?&out_of_fleet=false&client_group=' + groupUid
            }).then((response) => {
                let extremeResults = response.data.results.filter(vehicle => this.getVehicleInspectionStatus(vehicle).toLowerCase() === 'extreme');
                this.$store.dispatch('setExtremeVehiculesInspectionCount', extremeResults.length);
            });
            this.$store.axios.get(window.config.api_root_url + '/inspection-request/stats/?archived=false&client_has_answered=false&client_group='
                + groupUid)
                .then((response) => {
                    this.$store.dispatch('setNumberRequests', response.data.objects_count);
                });
        },
    }
};
</script>

<style lang="scss">
.fleet-button-grid-item {
    margin: 0 0 !important;
    white-space: normal !important;
}

.selected-button {
    background-color: #409EFF !important;
    color: #fff !important;

    &:active,
    &:hover,
    &:focus {
        background-color: #409EFF !important;
        color: #fff !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Fleets/fleet-button.vue